import * as ss from 'superstruct';
import { ConversionEventData } from '../data-provider/resources/conversions/conversion-data';

export const AuConversion = ss.type({
  /** Version number of this request. */
  v: ss.literal(1),

  /** User that generated this.
   *
   * Note that often this is just a UUID that represents a cookie based
   * session.  It's possible the same user may have multiple IDs.
   */
  userId: ss.string(),

  /** MS since epoch. */
  eventTimeMs: ss.number(),

  /** The event type. */
  eventType: ss.string(),

  /** Optional key, which allows for updating the same event.
   *
   * If this is set, then the key for this conversion will be:
   *
   *   `{userId}-{eventType}-{eventKey}`.
   *
   * Otherwise, it will be:
   *
   *   `{userId}-{eventType}-{eventTimeMs}`.
   **/
  eventKey: ss.optional(ss.string()),

  /** The event data.
   *
   * The structure of this object should be implied by `eventType`.
   */
  eventData: ConversionEventData,

  /**
   * Attribute this as a conversion and send it to Ad platforms (Meta / Google).
   *
   * Defaults to true.
   */
  attribute: ss.optional(ss.boolean()),

  /**
   * Friendly name for the conversion type.  Shown as "Conversion Type"
   * in emails, for example.
   */
  friendlyName: ss.optional(ss.string()),

  /**
   * Optional value of this conversion, which we will forward to the Ad
   * platforms (Meta / Google) to do better targeting.
   */
  value: ss.optional(ss.number()),

  /**
   * Optional field order for the conversion.  This is used to order fields
   * in emails, for example.  Fields not in this list will be appended after
   * in an undefined order.
   */
  fieldOrder: ss.optional(ss.array(ss.string())),
});

export type AuConversion = ss.Infer<typeof AuConversion>;
